import r from "./index402.js";
import { createElementBlock as t, openBlock as e } from "vue";
import n from "./index231.js";
const c = ["id"];
function s(o, p, a, i, d, m) {
  return e(), t("a", {
    id: o.id,
    "data-component": "MsAnchor"
  }, null, 8, c);
}
const u = /* @__PURE__ */ n(r, [["render", s]]);
export {
  u as default
};
